import { GalleryItem } from './gallery-item';
import { Localizzazione } from './localizzazione';
import { TraduzioneEvento } from './traduzione-evento';
import { FasciaApertura } from './fascia-apertura';
import { Time } from '@angular/common';
import { RaccomandazioneResponse } from './raccomandazione';
import { Image } from '@ks89/angular-modal-gallery';

export class Evento {
    id: string;
    language?: string;
    title?: string;
    typeElement?: {
        key?: string,
        label?: string
    };

    categories?: Array<{
        key?: string,
        label?: string
    }>;

    categoriesKeys?: Array<string>;
    categoriesLabels?: string;



    shortDescription?: string;
    extendedDescription?: string;

    thumbnail?: string;
    image?: string;
    captionImage?: String;



    address?: string;
    nhouse?: string;
    city?: string;
    province?: string;
    zipCode?: number;
    geoLocation?: Localizzazione;

    telephone?: string;
    webSite?: string;
    email?: string;

    services?: Array<string>;
    languagesSpoken?: Array<string>;

    opening?: Array<FasciaApertura>;
    infoOpening?: string;

    airport?: string;
    highway?: string;
    transport?: string;
    carParks?: string;
    accessibility?: string;
    reservation?: boolean;
    freeEntry?: boolean;
    price?: string;


    distanceFromPoint?: {
        distance?: number,
        uom?: string;
    }


    //Potrei non considerarlo, perchè gli passiamo la lingua
    //translation?: Array<TraduzioneEvento>;


    periodoEventoShort?: string;
    periodoEventoLong?: string;
    indirizzoEsteso?: string;

    isFavourite: boolean;

    dataInizioEvento?: Date;
    dataFineEvento?: Date;

    //Data nel formato DD/MM/YYYY
    startDate?: {
        EEEE?: string;
        d?: string;
        MMMM?: string;
        MMM?: string;
        YYYY?: string;
        YY?: string;
      };
      
    endDate?:  {
        EEEE?: string;
        d?: string;
        MMMM?: string;
        MMM?: string;
        YYYY?: string;
        YY?: string;
      };


    orarioEvento?: String;
    periodoDurataEvento?: number;

    giorniAllEvento?: number;

    raccomandation?: RaccomandazioneResponse;
    keywords?: any;


    gallery?: any;
    galleryImages?: Image[];
}
